import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/core/layouts/loader/loader.service';
import { EnvService } from 'src/environments/environment';

@Component({
  selector: 'app-statistiques',
  templateUrl: './statistiques.component.html',
  styleUrls: ['./statistiques.component.scss']
})
export class StatistiquesComponent implements OnInit {

  statsEndpoint: string = '/api/statistics'

  public workingMode : string = 'Viewer';
  public workingModelSelect: boolean = false;
  public extensions : any = {
    'data-source-wizard': {  
      enableCustomSql: true  
    }  
  };

  constructor(
    private loaderService: LoaderService,
    private envService: EnvService) { 
      this.statsEndpoint = this.envService.apiUrl + '/api/statistics';
  }

  ngOnInit(): void {
    this.workingModelSelect = false;
    this.workingMode = 'Viewer';
  }

  onSwitchWorkingMode(e) {
    
    if (e.value) {
      this.workingMode = 'Designer';
    } else {
      this.workingMode = 'Viewer';
    }
  }

}
